export const COLORS = {
  PrimaryAccentColor: '#CDAC3D',
  DarkAccentColor: '#222222',
  SecondaryAccentColor: '#D8A626',
  TopBarColorVenueName: '#cdac3d',
  TopBarColorBg: '#343A40',
  TopBarColorText: '#8C8C8D',
  TopBarColorTextHover: '#FFFFFF',
  TopBarColorTextSelected: '#343A40',
  TitleTextColor: 'white',
  ListItemBackgroundColor: '#343A40',
  PageBackgroundColor: '#222222',
  GoldStrong: '#DAA520',
  GoldMediumStrong: '#D8A626',
  GoldMediumWeak: '#E1B439',
  GoldMedium: '#f6d365',
  DarkGrey: '#222222',
  LightGrey: '#343A40',
  LighterGrey: '#989898',
  BlueMatte: '#3494D5',
  RedMatte: '#E24A3B',
  GreenMatte: '#2CC66D',
  White: '#FFFFFFFF',
  LiteralCssGold: 'gold',
};
